import React from "react";
import styled, { css } from "styled-components";

const BuyOrHireIconStyles = styled.div`
  ${({ ...props }) => css`
    width: 84px;
    height: 84px;
    border: solid 3px;
    border-radius: 50%;
    line-height: 16px;
    text-align: center;
    padding: 15px 18px;
    font-weight: 700;
    margin-top: -24px;
  `}
`;

export default function BuyOrHireIcon() {
  return <BuyOrHireIconStyles>Hire or Buy</BuyOrHireIconStyles>;
}
